 import {CriteriaDictionary} from '../interfaces';
import {CriteriaModel} from './criteria.model';

export class AdvancedSearchModel {
    criteria: CriteriaDictionary = {};
    name: string;
    criteriaAttributeDictionary: any[];
}
